import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import axios from "axios";
import { showSuccessToast, showErrorToast } from "../../Utils/toastUtils";

const DeleteManualVideoMany = (props) => {
    // const submit = props.submit
    const getData = props.getData
    const modal4 = props.modal
    const setModal4 = props.setModal
    const deleteArray2 = props.deleteArray2
    // const id = props.currentID

    console.log(props)
    // const id = props.id

    const cancelDelete = (e) => {
        e.preventDefault();
        setModal4(!modal4)
    }

    const deleteVideo = async (e) => {
        e.preventDefault();
        console.log("deleting the individual video or multiple")
        console.log(deleteArray2)
        axios.delete(`/api/upload/mandelete`,{ data: { "ids": deleteArray2 }, 
          headers: {
            Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
          },
        })
          .then(response => {
            console.log(response)
            showSuccessToast(response.data && response.data.Message.substring(0,15) ? response.data.Message : "Success")
            console.log(response.data.Message)
            getData()
            setModal4(false)
          })
          .catch(error => {
            showErrorToast( "Failed")
          });
      }



    return (
        <div>
            <Modal size="md" isOpen={modal4} toggle={() => setModal4(!modal4)}>
                <ModalHeader toggle={() => setModal4(!modal4)}>
                    Delete Videos
                </ModalHeader>
                <ModalBody>
                    <form >
                    <div className="d-flex justify-content-center">
                            Are you sure you want to delete?
                        </div>
                        <div className="d-flex justify-content-center">
                            <button
                                type="submit"
                                className="btn btn-secondary m-4"
                                onClick={(e) => cancelDelete(e)}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary m-4"
                                onClick={(e) => deleteVideo(e)}
                            >
                                Delete
                            </button>
                        </div>
                    </form>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default DeleteManualVideoMany;
